import { Card } from "./ui/card";
import { CreditCard, ActivitySquare, Plug, ChevronRight } from "lucide-react";

const TILES = [
  { key: "billing", testid: "admin-tile-billing", label: "Billing", sub: "Subscriptions · invoices · failed payments", Icon: CreditCard, tab: "billing", cls: "bg-slate-900 text-white hover:bg-slate-800" },
  { key: "diagnostics", testid: "admin-tile-diagnostics", label: "Diagnostics", sub: "Email · webhooks · deliveries", Icon: ActivitySquare, tab: "billing", cls: "bg-slate-100 text-slate-900 hover:bg-slate-200 border-slate-200" },
  { key: "integrations", testid: "admin-tile-integrations", label: "Integrations", sub: "Stripe · Resend · per campaign", Icon: Plug, tab: "settings", cls: "bg-slate-100 text-slate-900 hover:bg-slate-200 border-slate-200" },
];

export default function OwnerAdminRow({ onNavigate }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="owner-admin-row">
      {TILES.map(({ key, testid, label, sub, Icon, tab, cls }) => (
        <Card
          key={key}
          onClick={() => onNavigate?.(tab)}
          className={`p-4 cursor-pointer transition-all border ${cls}`}
          data-testid={testid}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onNavigate?.(tab); } }}
        >
          <div className="flex items-start gap-3">
            <div className={`h-9 w-9 rounded-lg flex items-center justify-center ${key === "billing" ? "bg-white/10" : "bg-white"}`}>
              <Icon className={`h-4 w-4 ${key === "billing" ? "text-white" : "text-slate-700"}`}/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm">{label}</div>
              <div className={`text-[11px] mt-0.5 ${key === "billing" ? "text-slate-300" : "text-slate-500"}`}>{sub}</div>
            </div>
            <ChevronRight className={`h-4 w-4 ${key === "billing" ? "text-slate-300" : "text-slate-400"}`}/>
          </div>
        </Card>
      ))}
    </div>
  );
}
